// extracted by mini-css-extract-plugin
module.exports = {"wrapSearch":"styles_wrapSearch__3WDWN","searchInput":"styles_searchInput__2vOFg"};